//import core
import core from "js/site/shared/Core";

const promises = [new Promise(() => core.init())];

Promise.all(promises).then(loadPlugins());

function loadPlugins() {
  console.log("Plugins loaded");

  $(window).scroll(function () {
    const pageHeading = $("section.page-heading");
    const shrinkIt = pageHeading.height();
    const scroll = $(window).scrollTop();

    if (scroll >= shrinkIt) {
      pageHeading.addClass("fixed-post-title");
    } else {
      pageHeading.removeClass("fixed-post-title");
    }
  });

  const shareButtons = document.querySelectorAll("a.open-share-window");

  shareButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const windowWidth = 650,
        windowHeight = 450,
        shareUrl = this.dataset.url,
        shareTitle = e.target.title;

      window.open(
        shareUrl,
        shareTitle,
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${windowWidth},height=${windowHeight},top=${
          (screen.height - windowHeight) / 2
        },left=${(screen.width - windowWidth) / 2}`
      );
    });
  });
}
